import { FilterDto, FilterType } from '../../../types/FilterDto';
import type { TFunction } from "i18next";
import { ImprovementPlanStatusEnum } from '../types/enums';
import { getFilters } from '../../admin/Dictionaries/api/basicGenericTable';

export const getFiltersImprovementPlans = async (t: TFunction<[string], undefined>): Promise<FilterDto[]> => {
    const typeFilter: FilterDto = await getFilters("improvementPlanType");
    typeFilter.description = t ? t("improvementPlan:filters.labelType") : "ImprovementPlansTypes";
    typeFilter.values = [
        { key: -1, value: t("improvementPlan:filters.labelUnassignedType") },
        ...(typeFilter.values ?? [])
    ];

    const staticFilters: FilterDto[] = [
        {
            name: 'Status',
            description: t("improvementPlan:filters.labelStatus"),
            type: FilterType.MULTIPLE,
            values: Object.keys(ImprovementPlanStatusEnum)
                .filter((key) => isNaN(Number(key)))
                .map((value) => ({
                    key: ImprovementPlanStatusEnum[value as keyof typeof ImprovementPlanStatusEnum],
                    value: t(`improvementPlan:form.status.${value}`)
                }))
        },
        {
            name: 'StartDate',
            description: t("common:form.fields.startDate"),
            type: FilterType.DATE,
            values: []
        },
        {
            name: 'EndDate',
            description: t("common:form.fields.endDate"),
            type: FilterType.DATE,
            values: []
        }

    ];


    return [...staticFilters, typeFilter];
};
